<template>
    <PageHeader :crumbs="[{ label: $t('portal.sidebar.purchased') }]" />

    <div class="tw-p-2">
        <div class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
            <h2 class="tw-font-semibold tw-text-gray-700 tw-mb-4">{{ $t('portal.purchased.title') }}</h2>

            <DataTable :columns="columns" :loading="loading" :count="items.length">
                <tr v-for="p in items" :key="p.id" :class="rowClass">
                    <td :class="cellClass"><span class="tw-font-medium tw-text-gray-800">{{ p.product_name }}</span></td>
                    <td :class="cellClass"><span class="tw-capitalize">{{ p.product_type }}</span></td>
                    <td :class="cellClass"><StatusBadge :status="p.status" /></td>
                    <td :class="cellClass">{{ fmt.date(p.start_date) }}</td>
                    <td :class="cellClass">{{ p.expiry_date ? fmt.date(p.expiry_date) : $t('common.without') }}</td>
                </tr>
            </DataTable>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { purchased } from '@/api/portal';
import PageHeader from '@/components/PageHeader.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import DataTable from '@/components/table/DataTable.vue';
import { useFormat } from '@/composables/useFormat';
import { rowClass, cellClass } from '@/composables/useTableStyles';

const i18n = useI18n();
const fmt = useFormat();
const items = ref([]);
const loading = ref(false);

const columns = computed(() => [
    { label: i18n.t('fields.product') },
    { label: i18n.t('portal.fields.type'), classes: ['tw-w-[140px]'] },
    { label: i18n.t('fields.status'), classes: ['tw-w-[120px]'] },
    { label: i18n.t('portal.fields.start-date'), classes: ['tw-w-[140px]'] },
    { label: i18n.t('portal.fields.expiry-date'), classes: ['tw-w-[150px]'] },
]);

async function load() {
    loading.value = true;
    try {
        const { data } = await purchased();
        items.value = data.purchases || [];
    } catch (e) { /* interceptor */ } finally {
        loading.value = false;
    }
}

load();
</script>
